import React from 'react'

export default function Section4() {
    return (
        <div className='w-[90%] mx-auto pb-10 lg:pb-20'>
            <div data-aos='fade-up' data-aos-duration='1500'>
            <h1 className='text-[#269DDF] text-center font-bold text-2xl lg:text-3xl uppercase'>Why Choose Us?  </h1>
            <p className='text-center lg:w-[60%] mx-auto mt-3'>Choosing the right platform for your OTC trades is crucial to ensure a seamless, secure, and efficient experience. At Finkey Star, we’ve crafted a solution that caters to both individual and institutional traders, with features that prioritize security, compliance, and liquidity.  </p>
            </div>
            <div className='mt-10 relative'>
                <div className='flex flex-col lg:flex-row  relative' style={{ zIndex: 1 }}>
                    <div className='w-[100%] lg:w-1/3 text-center lg:text-end grid gap-5 lg:gap-32'>
                        <div data-aos='fade-right' data-aos-duration='1500'>
                            <img src='/assets/icons/Sec4_1.svg' className='mx-auto lg:mx-0 lg:ml-auto mb-3'></img>
                            <h1 className='font-bold text-lg uppercase josefin-sans-regular'>Crypto-Fiat Flexibility</h1>
                            <p>Easily execute crypto-to-crypto, crypto-to-fiat, and fiat-to-crypto conversions, supporting multiple trading scenarios. </p>
                        </div>
                        <div  data-aos='fade-right' data-aos-duration='2000'>
                            <img src='/assets/icons/Sec4_2.svg' className='mx-auto lg:mx-0 lg:ml-auto mb-3'></img>
                            <h1 className='font-bold text-lg uppercase josefin-sans-regular'>Deep Liquidity</h1>
                            <p>Access large liquidity pools for the best rates and minimal slippage, enabling seamless trades. </p>
                        </div>
                    </div>
                    <div className='w-[100%] lg:w-1/3'>
                    <img src='https://fish-nft.s3.ap-south-1.amazonaws.com/lock.gif' data-aos='fade-in' data-aos-duration='1500' className='block lg:hidden mx-auto'></img>
                    </div>
                    <div className='w-[100%] lg:w-1/3 text-center lg:text-start grid gap-5 lg:gap-32'>
                        <div  data-aos='fade-left' data-aos-duration='1500'>
                            <img src='/assets/icons/Sec4_3.svg' className='mx-auto lg:mx-0 lg:mr-auto mb-3'></img>
                            <h1 className='font-bold text-lg uppercase josefin-sans-regular'>Unmatched Security</h1>
                            <p>Your assets are safeguarded with top-tier encryption and multi-layer security for secure transactions across all trades. </p>
                        </div>
                        <div  data-aos='fade-left' data-aos-duration='2000'>
                            <img src='/assets/icons/Sec4_4.svg' className='mx-auto lg:mx-0 lg:mr-auto mb-3'></img>
                            <h1 className='font-bold text-lg uppercase josefin-sans-regular'>P2P Trading</h1>
                            <p>Trade directly with other users, bypassing intermediaries for a more flexible and transparent OTC experience.</p>
                        </div>
                    </div>
                </div>
                <img src='https://fish-nft.s3.ap-south-1.amazonaws.com/lock.gif' data-aos='fade-in' data-aos-duration='1500' className='hidden lg:block absolute top-1/2 -translate-y-1/2 left-[53%] -translate-x-1/2'></img>
            </div>
        </div>
    )
}
